export default __webpack_public_path__ + "static/media/blog@2x.4f26f505.jpg";